<template>
  <div>
    <v-row class="ma-0 mt-1">
      <template v-for="card in cards">
        <v-col
          v-if="!card.ocultar"
          :key="card.titulo"
          cols="6"
          style="padding: 4px"
        >
          <CardQuantidadeTotal
            :card="card"
            :loading="loading"
            @card-selecionado="selecionarCard"
          />
        </v-col>
      </template>
    </v-row>

    <FiltrosTelaComprasProdutosGerais
      v-model="dialog_fornecedores_comprar"
      @update:filtros="irParaTelaComprasProdutosGerais"
    >
      <template #titulo-lado-esquerdo>
        <p class="ma-0 font-21">Produtos a comprar</p>
        <p class="ma-0 font-12 mt-n3 font-weight-regular text-gray-800">Selecione os filtros abaixo para acessar os produtos na tela de compras</p>
      </template>
    </FiltrosTelaComprasProdutosGerais>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import CardQuantidadeTotal from "./CardQuantidadeTotal";
import FiltrosTelaComprasProdutosGerais from "@/components/compra/ProdutosGerais/Filtros/Index";
import {colocarEmTelaCheia} from "@/helpers";

export default {
  components: {
    FiltrosTelaComprasProdutosGerais,
    CardQuantidadeTotal
  },
  props: ["cards", "loading"],
  data() {
    return {
      dialog_fornecedores_comprar: false
    };
  },
  computed: {
    ...mapState({
      fornecedor: state => state.fornecedor
    }),
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras"
    })
  },
  mounted() {
    this.selecionarCard(this.cards.fornecedores);
  },
  methods: {
    selecionarCard(cardSelecionado) {
      if (cardSelecionado === this.cards.produtosComprar) {
        this.dialog_fornecedores_comprar = true;
        return;
      }

      this.desabilitarTodos();
      this.setarAtivo(cardSelecionado);
      this.$emit("cardSelecionado", cardSelecionado);
    },
    desabilitarTodos() {
      const cards = Object.values(this.cards);
      cards.forEach(card => {card.ativo = false});
    },
    setarAtivo(cardSelecionado) {
      cardSelecionado.ativo = !cardSelecionado.ativo;
    },
    irParaTelaComprasProdutosGerais() {
      this.$router.push({ name: "CompraPorProdutosGerais" });
      this.Helpers.colocarEmTelaCheia();
    }
  }
};
</script>

<style scoped>
</style>
